import React, { FC, useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { PERMISSIONS } from "constants/permissions"

import { Login } from "../components/cards/Login"
import { URL } from "../constants/api/requests"
import { usePermissions } from "../contexts/PermissionsContext"
import { useProps } from "../contexts/PropsContext"

export const Home: FC = () => {
  const navigate = useNavigate()
  const { authenticated, user } = useProps()
  const { has } = usePermissions()

  useEffect(() => {
    if (authenticated && user) {
      navigate(has(PERMISSIONS.PAGE_DASHBOARD) ? URL.DASHBOARD : URL.USERS)
    }
  }, [authenticated, user, has, navigate])

  return (
    <div className="w-full h-full p-8 flex items-center justify-center">
      <Login />
    </div>
  )
}
